import { RouteProps } from '../../routes/AppRouter'
import React from 'react'
import { ResourcesForm as RF } from '../../features/resource'
import { ROUTE_CREATE } from '../../routes/routes-constants'
import { useTitleHeaderContext } from '../../common/utils/TitleHeaderContext'
import { Box } from '@mui/material'
import logoCareme from '../../assets/caremePlusLogo.svg'
import style from '../layout/Main.module.css'
import { useParams } from 'react-router-dom'

type ResourcesFormProps = {} & RouteProps

export function ResourcesForm(props: ResourcesFormProps) {
  const title = props.title || ''
  const { setTitle } = useTitleHeaderContext()
  const { id } = useParams()

  setTitle(title)

  return (
    <>
      <RF id={id === ROUTE_CREATE ? undefined : id} />
      <Box display={'flex'} justifyContent={'flex-end'}>
        <img src={logoCareme} alt="Logo Careme" className={style.logo} />
      </Box>
    </>
  )
}
